import * as Sentry from '@sentry/browser';

const shouldUseRaven = () => {
  if (__DEV__) {
    return false;
  } else if (typeof window === 'undefined') {
    return false;
  } else {
    return true;
  }
};

const SentryManager = {
  captureException: (error: Error, options = {}) => {
    if (!shouldUseRaven()) {
      console.error(error);
      return;
    }

    Sentry.captureException(error, options);
  },

  init: (dsn: string) => {
    if (!dsn) {
      console.error('[Sentry]: Missing DSN for init');
      return;
    }

    if (!shouldUseRaven()) {
      return;
    }

    Sentry.init({
      environment: __DEV_ENV__ ? 'dev' : __STAGING__ ? 'staging' : 'production',
      dsn,
    });
  },
};

export default SentryManager;
